import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actionCreators, selectors } from 'dux/org';
import InvoiceCard from './InvoiceCard';

const propTypes = {
  getUpcomingInvoice: PropTypes.func.isRequired,
  getPastInvoices: PropTypes.func.isRequired,
  org: PropTypes.shape({
    id: PropTypes.string,
    billingType: PropTypes.number,
    billingSetupComplete: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  org: selectors.getOrgState(state),
  isFastlaneCustomer: selectors.isFastlaneCustomerSelector(state),
});

const mapDispatchToProps = {
  getUpcomingInvoice: actionCreators.getUpcomingInvoice,
  getPastInvoices: actionCreators.getPastInvoices,
};

class UnstyledInvoiceCardContainer extends Component {
  componentDidMount() {
    const { getUpcomingInvoice, getPastInvoices, org } = this.props;
    if (org.billingSetupComplete && org.billingType === 1) {
      getUpcomingInvoice(org.id);
      getPastInvoices(org.id);
    }
  }

  render() {
    const { props } = this;
    return <InvoiceCard {...props} />;
  }
}

UnstyledInvoiceCardContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(UnstyledInvoiceCardContainer);
